import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const features = [{
  title: 'Fórmulas con Medidas Reales',
  description: 'Nada de "aproximado". Cada receta viene con proporciones exactas.'
}, {
  title: 'Lista Clara de Materiales',
  description: 'Qué comprar. Qué evitar. Cuánto necesitas de cada cosa.'
}, {
  title: 'Guía Anti-Errores',
  description: 'Qué hacer si se corta la mezcla. Qué hacer si queda blando. Cómo evitar que se quiebre. Cómo lograr firmeza perfecta.'
}, {
  title: 'Técnicas de Aroma y Color Profesional',
  description: 'Cómo perfumar correctamente. Cómo lograr colores intensos sin dañar la fórmula.'
}, {
  title: 'Módulo de Venta Desde Casa',
  description: 'Cómo calcular costos. Cómo presentar. Cómo armar combos atractivos. Cómo empezar a generar ingresos reales.'
}];
export function Features() {
  return <section className="w-full bg-[var(--bg-darker)] py-20 px-4" data-id="element-34">
      <div className="max-w-5xl mx-auto" data-id="element-35">
        <motion.h2 className="text-4xl md:text-5xl font-black text-[var(--text-light)] mb-4 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-36">
          ¿Qué Incluye Exactamente?
        </motion.h2>

        <div className="space-y-6 mt-12" data-id="element-37">
          {features.map((feature, index) => <motion.div key={index} className="bg-[var(--bg-card)] p-6 md:p-8 rounded-xl border-l-4 border-[var(--accent-orange)]" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.6
        }} data-id="element-38">
              <div className="flex items-start gap-4" data-id="element-39">
                <CheckCircle2Icon className="w-8 h-8 md:w-10 md:h-10 text-[var(--accent-orange)] flex-shrink-0 mt-1" aria-hidden="true" data-id="element-40" />
                <div data-id="element-41">
                  <h3 className="text-xl md:text-2xl font-bold text-[var(--text-light)] mb-2" data-id="element-42">
                    {feature.title}
                  </h3>
                  <p className="text-lg md:text-xl text-[var(--text-gray)]" data-id="element-43">
                    {feature.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div className="mt-16 text-center bg-gradient-to-r from-[var(--accent-orange)] to-[var(--accent-orange-hover)] p-8 md:p-12 rounded-2xl" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.6
      }} data-id="element-44">
          <h3 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-45">
            El Gran Número
          </h3>
          <p className="text-xl md:text-2xl text-white mb-4" data-id="element-46">
            Dentro del Método tienes acceso inmediato a:
          </p>
          <p className="text-5xl md:text-6xl lg:text-7xl font-black text-white" data-id="element-47">
            39 Fórmulas y Recetas Completas
          </p>
          <p className="text-xl md:text-2xl text-white mt-4" data-id="element-48">
            Que puedes usar hoy mismo.
          </p>
          <p className="text-lg md:text-xl text-white/90 mt-6" data-id="element-49">
            No es una receta suelta. Es un arsenal completo.
          </p>
        </motion.div>
      </div>
    </section>;
}